import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'data-table-row',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    row: {
      borderBottom: `4px solid ${theme.palette.background.default}`,
      transition: 'opacity 0.2s',
    },
    expandableRow: {
      '&:not($expandedRow)': {
        border: 0,
      },
      '&:not($expandedRow) + tr': {
        border: 0,
        opacity: 0,
      },
    },
    expandedRow: {},
    collapsibleRow: {
      '& $cell': {
        padding: 0,
      },
    },
    collapsedRow: {
      border: 0,
      '& $cell': {
        opacity: 0,
      },
    },
    cell: {
      padding: 0,
      backgroundColor: theme.palette.common.white,
      border: 0,
      paddingLeft: 16,
      paddingRight: 16,
      '&:first-child': {
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
      },
      '&:last-child': {
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
      },
    },
    cellWrap: {
      minHeight: 62,
      display: 'flex',
      alignItems: 'center',
    },
    expandButtonWrap: {
      padding: theme.spacing(0, 1.5),
      borderLeft: `1px solid ${theme.palette.grey[50]}`,
      height: 54,
    },
    expandButton: {
      '& svg': { fill: 'none', transition: '.2s' },
    },
    expandButtonExpanded: {
      '& svg': { transform: 'rotate(180deg)' },
    },
  }),
  options
);

export default useStyles;
